import { SDKRequest } from '../../../../shared/DiscordActivityTypes.ts';
import { UICoinProductView } from '../../../shared/scripts/store/UICoinProductView.ts';
import { DiscordInstance } from '../discord/DiscordInstance.ts';
import { isPurchaseUnavailableOnPlatform, showUnavailableOnMobilePopup } from '../../../shared/scripts/store/StoreUtils.ts';
import { AudioManager, AudioType } from '@colonist/audio';
import { sendPurchaseSessionStartedAnalytic } from '../../../shared/scripts/analytics/sendPurchaseFunnelAnalytic.ts';
export class UIDCoinProductView extends UICoinProductView {
    handleBuyButtonClicked() {
        AudioManager.play(AudioType.Click);
        if (isPurchaseUnavailableOnPlatform()) {
            showUnavailableOnMobilePopup();
            return;
        }
        sendPurchaseSessionStartedAnalytic({
            storeProductType: this.product.storeProductType,
            productType: this.product.type,
            method: 'discord'
        });
        void DiscordInstance.getDiscordInstance().sendSDKRequest(SDKRequest.PurchaseCoins, this.product.type);
    }
}
